<p-toast position="top-right" [life]="3500" />
<p-confirmdialog styleClass="ycc-confirm-dialog" />
<router-outlet />
